<template>

   <div class="flex items-center justify-center" :class="textClass">
                        <img :src="logoFile" class="mr-3 h-6 sm:h-9 w-auto"
                             :alt="BRAND_NAME + ' Logo'"/>
                    </div>

</template>
<script setup>
import { BRAND_NAME } from "@/constants.js";
import {computed} from "vue";
import {isServer} from "@/helpers.js";
 const props = defineProps({
     class: {
         type: String,
         default: ''
     },
     textClass: {
         type: String,
         default: ''
     },
     variant: {
         type: String,
         default: ''
     }
 })
let isDarkMode = computed(() => {
    if (isServer()) return false;
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
})


const logoFile = computed(() => {
    if (props.variant && props.variant === 'white') {
        return '/assets/images/mockready-logo-mn-white.svg'
    } else if (props.variant && props.variant === 'primary') {
        return '/assets/images/mockready-logo-mn.svg'
    }

    if (isDarkMode.value) {
        return '/assets/images/mockready-logo-mn-white.svg'
    } else {
        return '/assets/images/mockready-logo-mn.svg'
    }
})

</script>
